import BaseService from "./BaseService";

export default class RateReconciliationService extends BaseService {

    public static getAllRateReconciliationList(token: string, postData: any, isCsv = false) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/placeholder-list${isCsv ? '-Csv' : ''}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

}